import type { IconData } from '@stacksjs/iconify-core'

export const musicNotesMusic1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 7.625h1.53v3.04h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M25.135 4.575h1.53v1.52h-1.53Zm-6.09 18.28h3.05v-1.52h1.52V4.575h1.52v-1.53h-1.52v-1.52h-1.52v15.24h-3.05v1.52h-1.52v3.05h1.52zm-6.1-7.62h1.53v3.05h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.52-1.52h1.52v1.52h-1.52Zm-6.1 18.28h3.05v-1.52h1.52v-16.76h1.53v-1.53h-1.53v-1.52h-1.52v15.24h-3.05v1.52h-1.52v3.05h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default musicNotesMusic1
